import {ref} from 'vue';
import {defineStore, storeToRefs} from 'pinia';
import type {PredictCategoryResource, ProfileFamilyResource} from '@api';
import {Configuration, PublicProfileCategorizationApi} from '@api';
import {useInfosRequest} from '~/composables/useInfosRequest';
import type {UpdateCategorizationRequest} from '~/store/category/categorizationRepository';
import {categorizationRepository} from '~/store/category/categorizationRepository';
import {useProfileStore} from '~/store/profileStore';

export const useCategoryStore = defineStore('category', () => {
    const predictions = ref<PredictCategoryResource[]>([]);
    const families = ref<ProfileFamilyResource[]>([]);
    const profileStoreRequest = useInfosRequest();
    const profileStore = useProfileStore();
    const {profile} = storeToRefs(profileStore);
    const loading = ref<boolean>(true);
    const api = new PublicProfileCategorizationApi(new Configuration({basePath: ''}));

    async function loadPredictions(): Promise<void> {
        predictions.value = await api.suggestCategories({predictCategoryRequest: {headline: profile.value!.headline}});
        loading.value = false;
    }

    async function loadPredictionsForJobTitle(jobTitle: string): Promise<PredictCategoryResource[]> {
        predictions.value = await api.suggestCategories({predictCategoryRequest: {headline: jobTitle}});
        loading.value = false;

        return predictions.value;
    }

    async function loadFamilies(): Promise<ProfileFamilyResource[]> {
        families.value = await api.allFamilies();
        return families.value;
    }

    function unloadPredictions() {
        predictions.value = [];
    }

    async function save(request: UpdateCategorizationRequest): Promise<void> {
        await categorizationRepository.save(request, profile.value!);
        await profileStore.getProfile(profileStoreRequest);
    }

    return {
        predictions,
        families,
        loading,
        loadPredictions,
        loadPredictionsForJobTitle,
        loadFamilies,
        unloadPredictions,
        save,
    };
});
